import { useFormikContext } from "formik";
import React from "react";
import { Col, Form, Row } from "react-bootstrap";

import { CountryWithCode, StateWithCode } from "../../../../config/filingConstants";
import { ISaleLandAndBuildingForm } from "../../../../config/interfaces";
import { UtilService } from "../../../../services";
import { FormField, NumericInputField, SelectInputField, TextInputField } from "../../../fields";

type Props = {};

const CGSaleLandAndBuildingAddressForm: React.FC<Props> = (props: Props) => {
  const {} = props;

  const { values, errors, touched, setFieldValue, handleBlur } =
    useFormikContext<ISaleLandAndBuildingForm>();

  return (
    <>
      <section className="mb-5">
        <p className="leading-para fw-bold text-primary">Property Address</p>

        <FormField label="Property Address" sm={4}>
          <TextInputField
            name="PropertyAddress"
            value={values.PropertyAddress}
            onChange={(value) => setFieldValue("PropertyAddress", value)}
            onBlur={(e) => {
              handleBlur(e);
              setFieldValue("PropertyAddress", values.PropertyAddress.trim());
            }}
            isInvalid={Boolean(errors.PropertyAddress) && touched.PropertyAddress}
            errorMsg={errors.PropertyAddress}
          />
        </FormField>

        <FormField label="Address Line" isRequired={true} sm={4}>
          <TextInputField
            name="AddressLine"
            value={values.AddressLine}
            onChange={(value) => setFieldValue("AddressLine", value)}
            onBlur={(e) => {
              handleBlur(e);
              setFieldValue("AddressLine", values.AddressLine.trim());
            }}
            isInvalid={Boolean(errors.AddressLine) && touched.AddressLine}
            errorMsg={errors.AddressLine}
          />
        </FormField>

        <FormField label="Pincode" isRequired={true} sm={4}>
          <NumericInputField
            decimalUpto={0}
            separator=""
            name="PinCode"
            value={values?.PinCode || ""}
            onChange={async (value) => {
              setFieldValue("PinCode", Number(value));
              setFieldValue("ZipCode", value);

              if (value.length === 6) {
                const data = await UtilService.getStateCityFromPincode(value);
                if (data) {
                  setFieldValue("CountryCode", data.CountryCode);
                  setFieldValue("StateCode", data.StateCode);
                  setFieldValue("CityOrTownOrDistrict", data.CityOrTownOrDistrict);
                } else {
                  setFieldValue("CountryCode", "");
                  setFieldValue("StateCode", "");
                  setFieldValue("CityOrTownOrDistrict", "");
                }
              }
            }}
            onBlur={handleBlur("PinCode")}
            isInvalid={Boolean(errors.PinCode) && touched.PinCode}
            errorMsg={errors.PinCode}
          />
        </FormField>

        <Row className="align-items-center">
          <Col sm={4}>
            <Form.Label className="required-field mb-0">Country | State | City</Form.Label>
          </Col>
          <Col>
            <Row className="align-items-center">
              <Col sm={4}>
                <SelectInputField
                  placeholder="Select Country"
                  label="Country"
                  name="CountryCode"
                  isSearchable={true}
                  isOptionArrayOfObject={true}
                  options={UtilService.convertToArray(CountryWithCode)}
                  value={{
                    "label": CountryWithCode[values.CountryCode],
                    "value": values.CountryCode
                  }}
                  onChange={(selectedCountry) => {
                    if (selectedCountry) {
                      setFieldValue("CountryCode", selectedCountry.value);
                      if (selectedCountry.value !== "91") {
                        setFieldValue("StateCode", "99");
                      } else {
                        setFieldValue("StateCode", "");
                      }
                    } else {
                      setFieldValue("CountryCode", undefined);
                    }
                  }}
                  onBlur={handleBlur("CountryCode")}
                  isInvalid={Boolean(errors.CountryCode) && touched.CountryCode}
                  errorMsg={errors.CountryCode}
                />
              </Col>
              <Col sm={4}>
                <SelectInputField
                  placeholder="Select state"
                  name="StateCode"
                  label="State"
                  isSearchable={true}
                  isOptionArrayOfObject={true}
                  options={UtilService.convertToArray(StateWithCode)}
                  value={{
                    "label": StateWithCode[values.StateCode],
                    "value": values.StateCode
                  }}
                  onChange={(selectedState) => {
                    if (selectedState) {
                      setFieldValue("StateCode", selectedState.value);
                    } else {
                      setFieldValue("StateCode", undefined);
                    }
                  }}
                  onBlur={handleBlur("StateCode")}
                  isInvalid={Boolean(errors.StateCode) && touched.StateCode}
                  errorMsg={errors.StateCode}
                />
              </Col>
              <Col sm={4}>
                <TextInputField
                  label="City"
                  name="CityOrTownOrDistrict"
                  value={values.CityOrTownOrDistrict}
                  onChange={(value) => setFieldValue("CityOrTownOrDistrict", value)}
                  onBlur={handleBlur("CityOrTownOrDistrict")}
                  isInvalid={Boolean(errors.CityOrTownOrDistrict) && touched.CityOrTownOrDistrict}
                  errorMsg={errors.CityOrTownOrDistrict}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </section>
    </>
  );
};

export default CGSaleLandAndBuildingAddressForm;
